import { Component } from '@angular/core';

/**
 * Renders the dashboard page
 */
@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts